import React, { useState, useRef } from 'react';
import LeftSidebar from '../Tools/LeftSidebar';
import Topbar from '../Tools/Topbar';
import Settings from '../Tools/Setting/Settings';
import useSettings from '../Tools/Setting/useSettings';

const Profile = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const { settings, updateSetting, handleColorTheme } = useSettings();
  const settingsRef = useRef();

  return (
    <div id="main-wrapper">
      <LeftSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div className={`page-wrapper ${isSidebarOpen ? '' : 'sidebar-closed'}`}>
        <Topbar toggleSidebar={toggleSidebar} />
        <div className="body-wrapper">
          <div className="container-fluid">
            <Settings
              ref={settingsRef}
              updateSetting={updateSetting}
              handleColorTheme={handleColorTheme}
              settings={settings}  // Add this line
            />
          
          
          <div class="card w-100 position-relative overflow-hidden">
            <div class="px-4 py-3 ">
              <h5 class="card-title fw-semibold mb-0 lh-sm">Contact Us</h5>
              <p class="card-subtitle mb-0 mt-1">We’re here to help. Reach out to us anytime with your questions or feedback.</p>
            </div>
            <div class="card-body p-4">
              <div class="py-3 px-0">
                <div class="profile-first-panel">

                  <div class="col-lg-8">
                    <div class="row mb-3">
                      <div class="col-sm-4">
                        <h6 class="fw-semibold mb-0">Email:</h6>
                      </div>
                      <div class="col-sm-8">
                        <p class=" mb-0">support@wavetechsa.com</p>
                      </div>
                    </div>  
                    <div class="row mb-3">
                      <div class="col-sm-4">
                        <h6 class="fw-semibold mb-0">Phone: </h6>
                      </div>
                      <div class="col-sm-8">
                        <p class=" mb-0">+966 5 0000 0000 (Saudi Arabia)</p>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-sm-4">
                        <h6 class="fw-semibold mb-0">Support Hours:</h6>
                      </div>
                      <div class="col-sm-8">
                        <p class=" mb-0">24/7.</p>
                      </div>
                    </div>
                    
                  </div>
                </div>
                <hr class="my-5"/>

                <div class="profile-edit-form">
                  <h5 class="card-title fw-semibold mb-4 lh-sm">Contact Form </h5>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label>First Name</label>
                        <input type="text" class="form-control"/>
                      </div>
                    </div>
                   
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label>Last Name</label>
                        <input type="text" class="form-control"/>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-3">
                        <label>Email Address</label>
                        <input type="text" class="form-control"/>
                      </div>
                    </div>
                   
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label>Phone Number</label>
                        <input type="text" class="form-control"/>
                      </div>
                    </div>  

                    <div class="col-md-12">
                      <div class="mb-3">
                        <label>Subject</label>
                        <input type="text" class="form-control"/>
                      </div>
                    </div> 
                    
                    <div class="col-md-12">
                      <div class="mb-3">
                        <label>Message</label>
                        <textarea class="form-control" rows="5"></textarea>
                      </div>
                    </div>
                    
                    
                    <div class="col-md-6">
                      <button type="submit" class="btn waves-effect waves-light btn-outline-primary">
                        Submit 
                      </button>
                    </div>
                   
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
            
          </div>
        </div>
     
  );
};

export default Profile;